import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {hot} from "react-hot-loader";

import useStarfishAPI from 'hooks/useStarfishAPI';
import {urlParams} from '../../utils/request';
import SuccessScoreView from "./SuccessScoreView";
import Toast from 'common/Toast';

/* App organizes the data used to display success score information in the
 * profile box in the student folder.   Score can be calculated via op model retention
 * scoring process or the legacy success score process.
 *
 * If end user doesn't have permissions to view success scores this box is not shown.
 *
 * @param successScore - score from op model scoring or legacy success score process
 * @param termName - the score is calculated for this term
 * @param studentId - student who the score belongs to
 * @param riskLevel - Score retrieval process will determine score risk level (good,bad, ok) based on
 *                 SUCCESS_SCORE_RANGES tenant configuration
 * @returns {JSX.Element}
 * @constructor
 */
const App = ({
                 successScore,
                 termName,
                 studentId,
                 riskLevel,
                 opModelEnabled
             }) => {

    const [getResponse, callGetAPI] = useStarfishAPI();
    const [previousScores, setPreviousScores] = useState('')
    const [toastMessage, setToastMessage] = useState("");


    useEffect(() => {
        if (studentId) callGetAPI(`../student/getSuccessScoreHistory.html?${urlParams({studentId: `${studentId}`})}`, {method: 'GET'});
        else setToastMessage('A student ID must be provided.')
    }, []);

    useEffect(() => {
        if (getResponse && getResponse.success) {
            if (getResponse.data && getResponse.data.results && getResponse.data.results.length > 0)
                setPreviousScores(getResponse.data.results[getResponse.data.results.length - 1]);
        } else if (getResponse && getResponse.error)
            setToastMessage(getResponse.error);
    }, [getResponse]);

    return (
        <React.Fragment>
            <SuccessScoreView
                successScore={successScore}
                termName={termName}
                previousScoreDate={previousScores.statDate}
                previousScore={previousScores.data}
                riskLevel={riskLevel}
                opModelEnabled={opModelEnabled}/>
            {toastMessage && <Toast message={toastMessage} onTimeout={() => setToastMessage("")}/>}
        </React.Fragment>

    );
};

App.propTypes = {
    successScore: PropTypes.number,
    termName: PropTypes.string,
    studentId: PropTypes.number,
    riskLevel: PropTypes.string,
    opModelEnabled: PropTypes.bool
};

export default hot(module)(App);
